import Cookies from 'js-cookie';

export const tnewCookieKey = 'sessionKey';
export const getFixedCachedKey = (key: string) => `${key}-${Cookies.get(tnewCookieKey)}`;

export const getMetaDataCalledEvent = new Event('getMetaDataCalled');
export const performanceAddedEvent = new Event('performanceAdded');
export const performanceRemovedEvent = new Event('performanceRemoved');
export const sessionIsInactiveEvent = new Event('sessionIsInactive');

export const genericErrorMessage = 'An error has occurred. Please try again or contact our Box Office for assistance on (02) 8215 4600 or info@sydneysymphony.com.';
export const removeErrorMessage = 'An error has occurred. Please try again, reload the page or contact our Box Office for assistance on (02) 8215 4600 or info@sydneysymphony.com.';
